import { TSetReset } from '../actions';
import {
    TSetAppReset,
    TSetCurrentSessionData,
    TSetIsLoggedIn,
} from './actions.types';
import { TCurrentSessionData } from 'types/app';

export type TReducerState = {
    currentSessionData: TCurrentSessionData;
    isLoggedIn: boolean;
};

export enum EActionTypes {
    SET_CURRENT_SESSION_DATA = 'SET_CURRENT_SESSION_DATA',
    SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN',
    APP_RESET = 'APP_RESET',
}

export type TReduxActions =
    | ReturnType<TSetCurrentSessionData>
    | ReturnType<TSetIsLoggedIn>
    | ReturnType<TSetAppReset>
    | ReturnType<TSetReset>;
